export type ApiResponse<T> = {
  success: boolean
  data: T[]
  message?: string
  status?: number
  error?: unknown
}

function isApiResponseShape(x: any): x is ApiResponse<any> {
  return Boolean(x && typeof x === 'object' && typeof x.success === 'boolean' && Array.isArray(x.data))
}

function isLegacyOkShape(x: any): boolean {
  return Boolean(x && typeof x === 'object' && typeof x.ok === 'boolean' && 'data' in x)
}

export function unwrapList<T>(resp: unknown): T[] {
  const r: any = resp as any
  if (isApiResponseShape(r)) {
    return Array.isArray(r.data) ? (r.data as T[]) : []
  }
  if (isLegacyOkShape(r)) {
    const d = r.data
    return Array.isArray(d) ? (d as T[]) : d ? ([d] as T[]) : []
  }
  if (Array.isArray(r)) return r as T[]
  if (r && typeof r === 'object' && Array.isArray((r as any).data)) return (r as any).data as T[]
  return []
}

export function unwrapFirst<T>(resp: unknown): T | null {
  const list = unwrapList<T>(resp)
  return list.length > 0 ? list[0] : null
}
